export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/10 bg-[#050505] pt-24 pb-10"
    >
      <div className="px-6 md:px-14 lg:px-20 xl:px-24 grid grid-cols-1 md:grid-cols-12 gap-12 items-start">
        <div className="md:col-span-6">
          <img
            src="https://static1.squarespace.com/static/525bd8b5e4b0daa056d3ae62/t/609bdba60d591d31a96d63e6/1620827046291/COLAB+LOGO+BLACK+AND+WHITE+IMMERSIVE+THEATRE+LONDON.jpg"
            alt="COLAB Theatre — Best Immersive Theatre in London"
            className="h-28 md:h-36 w-auto object-contain"
          />
          <p className="mt-6 max-w-md text-white/60 text-sm leading-relaxed">
            COLAB Theatre — the best immersive theatre in London. Fourteen
            years, fifteen productions, and 65+ press reviews that call us the
            pinnacle of immersive. A byword for quality in immersive theatre.
          </p>
        </div>
        <div className="md:col-span-3">
          <div className="text-[10px] uppercase tracking-[0.3em] text-white/40 mb-4">
            Immersive Theatre Archive
          </div>
          <ul className="space-y-2 text-sm">
            <li><a className="link-hover" href="/">Home — Best Immersive Theatre London</a></li>
            <li><a className="link-hover" href="/reviews">Immersive Theatre Reviews</a></li>
            <li>
              <a
                className="link-hover"
                href="https://www.colabtheatre.co.uk"
                target="_blank"
                rel="noreferrer"
              >
                colabtheatre.co.uk
              </a>
            </li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <div className="text-[10px] uppercase tracking-[0.3em] text-white/40 mb-4">
            Immersive Theatre Press
          </div>
          <p className="text-sm text-white/60 leading-relaxed">
            65+ verified immersive theatre reviews of London&apos;s best
            immersive theatre — LondonTheatre1, The Guardian, The Stage, Time
            Out, BroadwayWorld, Morning Star and 30+ more.
          </p>
        </div>
      </div>
      <div className="mt-24 px-6 md:px-14 lg:px-20 xl:px-24 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[10px] uppercase tracking-[0.3em] font-mono text-white/40">
        <div>© {new Date().getFullYear()} COLAB Theatre. Best Immersive Theatre in London.</div>
        <div>Immersive Theatre Reviews · London · Since 2011</div>
      </div>
    </footer>
  );
}
